import React, { useEffect, useState } from "react";
import api from "../utils/axiosConfig";
import localforage from "localforage";
import Dashboard from "./Dashboard";

const API_URL = process.env.REACT_APP_API_URL;
const IMPORT_ADMINS = ["pardhasaradhi@showtimeconsulting.in"];

const BoothImport = () => {
  const [email, setEmail] = useState("");
  const [geo, setGeo] = useState({ districts: [], byDistrict: {} });
  const [district, setDistrict] = useState("");
  const [acNo, setAcNo] = useState("");
  const [file, setFile] = useState(null);
  const [lock, setLock] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const isAdmin = IMPORT_ADMINS.includes((email || "").trim().toLowerCase());

  const authHeader = async () => {
    const token = await localforage.getItem("token");
    return { Authorization: "Bearer " + token };
  };

  useEffect(() => {
    localforage.getItem("email").then((e) => setEmail(e || ""));
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const headers = await authHeader();
        const res = await api.get(`${API_URL}/booth-wise/geo`, { headers });
        setGeo(res.data || { districts: [], byDistrict: {} });
      } catch (e) { /* ignore */ }
    })();
  }, []);

  const doImport = async () => {
    if (!district || !acNo || !file) { setMsg("Pick District, Assembly and a CSV file."); return; }
    setBusy(true);
    setMsg("");
    try {
      const headers = await authHeader();
      const opt = (geo.byDistrict[district] || []).find((a) => String(a.ac_no) === String(acNo));
      const fd = new FormData();
      fd.append("district", district);
      fd.append("ac", opt ? opt.ac_name : "");
      fd.append("acNo", acNo);
      fd.append("lock", lock ? "true" : "false");
      fd.append("file", file);
      const res = await api.post(`${API_URL}/booth-wise/import-details`, fd, { headers });
      setMsg(res.data.message || "Imported.");
      setFile(null);
    } catch (e) {
      setMsg(e.response?.data?.error || "Import failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <Dashboard />
      <div style={{ padding: "20px", maxWidth: "820px", margin: "0 auto" }}>
        <h2 style={{ textAlign: "center" }}>Import Filled Booth Details</h2>
        {!isAdmin ? (
          <p style={{ textAlign: "center", color: "#6a7c93", padding: "30px" }}>
            You do not have access to import booth details.
          </p>
        ) : (
          <>
            <p style={{ color: "#6a7c93", textAlign: "center" }}>
              Upload a filled details CSV (District, AC, Part + the field columns).
              Rows are matched to booths by Part No. Blank rows are ignored, so a
              partly-filled sheet only updates the filled booths.
            </p>
            <div style={{ border: "1px solid #e3e9f1", borderRadius: "12px", padding: "16px", background: "#fbfcfe" }}>
              <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "end" }}>
                <div>
                  <label style={{ display: "block", fontSize: "13px" }}>District</label>
                  <select value={district} onChange={(e) => { setDistrict(e.target.value); setAcNo(""); }}>
                    <option value="">Select District</option>
                    {geo.districts.map((d) => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: "block", fontSize: "13px" }}>Assembly (AC)</label>
                  <select value={acNo} onChange={(e) => setAcNo(e.target.value)} disabled={!district}>
                    <option value="">Select Assembly</option>
                    {(geo.byDistrict[district] || []).map((a) => (
                      <option key={a.ac_no} value={a.ac_no}>{a.ac_no} - {a.ac_name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={{ display: "block", fontSize: "13px" }}>Filled CSV</label>
                  <input type="file" accept=".csv" onChange={(e) => setFile(e.target.files[0])} />
                </div>
              </div>
              <label style={{ display: "block", marginTop: "12px", fontSize: "14px" }}>
                <input type="checkbox" checked={lock} onChange={(e) => setLock(e.target.checked)} style={{ marginRight: "6px" }} />
                Mark imported booths as Submitted (locked). Leave unchecked to import as editable drafts.
              </label>
              <button type="button" onClick={doImport} disabled={busy}
                style={{ marginTop: "14px", background: "#1f6fd0", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", fontWeight: 600, cursor: "pointer" }}>
                {busy ? "Importing..." : "Import"}
              </button>
            </div>
            {msg && <p style={{ textAlign: "center", color: "#166534", fontWeight: 600, marginTop: "14px" }}>{msg}</p>}
          </>
        )}
      </div>
    </div>
  );
};

export default BoothImport;
